import React from 'react';
import Component from './Component';

const Education = () => {
  return (
    <section className='education page-wrap'>
      <div className="cmd">
        <span className="prompt">$</span> history
      </div>
      <div className="d-title">Education</div>

      <div className="card-list">
        <Component exam="BSc (Hons) Computer Science (Cyber Security)" grade="CGPA 3.74" time="November 2022 - April 2026" />
        <Component exam="Foundation in Science and Technology" grade="CGPA of 4.0" time="September 2021 - July 2022" />
        <Component exam="iGCSE" grade="9A*, 1A and 2B" time="September 2019 - September 2021" />
      </div>
    </section>
  )
}

export default Education
